import api from 'common/infra/api'
import { ELeadServiceStatus } from 'containers/App/appLayoutEnum'
import { IServiceLead } from 'containers/App/appLayoutTypes'
import { ELeadServiceOrderBy, ILeadService } from './types'

const LeadService: ILeadService = {
  get: (page = 1, per_page = 50) => {
    return api.get('/leads', { params: { page, per_page, order_by: '+status_lead_weight' } })
  },
  getLead: sellerId => {
    return api.get('/leads', {
      params: { page: 1, per_page: 1, order_by: '+status_lead_weight', seller_ids: sellerId },
    })
  },
  getServices: ({
    page = 1,
    per_page = 10,
    order_by = ELeadServiceOrderBy.NAME_ASC,
    status = ELeadServiceStatus.ACTIVE,
    type,
  }) => {
    return api.get<IServiceLead[]>('/leads/services', {
      params: { order_by, page, per_page, status, type },
    })
  },
  getIntegrationSelectionAvailable: (sellerId: string) =>
    api.get('/leads/integration-platform-selection-available', { params: { seller_id: sellerId } }),
  getSellerBrandsOptions: (startingWith: string, service_id: string) =>
    api.get('/leads/seller_service_brands', {
      params: { starting_with: startingWith, service_id },
    }),
  leadsAvailableChannel: (display_name, channelId, document) => {
    return api.get(
      `/leads/available?seller_id=${display_name}&channel_id=${channelId}&document=${document}`
    )
  },

  createLeadMinimal: ({ channelId, document, referralCode }) => {
    return api.post('/leads/minimal', {
      company: {
        document,
      },
      channel_id: channelId,
      referral_code: referralCode,
    })
  },
}

export default LeadService
